export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f8642ce3c2b64ef090924d43ae2bd77e3eb294e6d&name=fetchTypeahead!'